var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-button",
        {
          class: {
            "mb-2": _vm.isMarginBottom,
            "float-right": _vm.isRight,
            "float-left": _vm.isLeft
          },
          attrs: { variant: "info", to: _vm.dataUrl, title: "Create New Data" }
        },
        [_c("font-awesome-icon", { attrs: { icon: "plus" } })],
        1
      ),
      _vm._v(" "),
      _vm.clearfix ? _c("div", { staticClass: "clearfix" }) : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cfcd2ac0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cfcd2ac0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Buttons/CreateNewData.vue
// module id = sp86
// module chunks = 4